__turbopack_context__.v({
  "cartButton": "mobile-cart-float-button-module__wcXnYa__cartButton",
  "cartIcon": "mobile-cart-float-button-module__wcXnYa__cartIcon",
  "floatingContainer": "mobile-cart-float-button-module__wcXnYa__floatingContainer",
  "itemCount": "mobile-cart-float-button-module__wcXnYa__itemCount",
  "priceBadge": "mobile-cart-float-button-module__wcXnYa__priceBadge",
});
